/* eslint-disable security/detect-object-injection */
import './LBScoreCard.style.less'

import { Col, Spin } from 'antd'
import { LBF_QUERY_KEY, cardColors } from '../../Liveboard.constant'

import FlipFingerContainer from '@/components/FlipFingerContainer/FlipFingerContainer'
import LiveboardSpinner from '../LiveboardSpinner/LiveboardSpinner'
import ScoreCard from '@/components/ScoreCard/ScoreCard'
import { get } from 'lodash'
import { getScoreCard } from '../../QSFBoard/QSFBoard.transform'
import moment from 'moment'
import { useAuth } from '@/providers/auth.provider'
import { useQuery } from 'react-query'

interface Props {
  item: any
  index: number
  datePicked: moment.Moment[]
  data: any
}

function LBScoreCard({ item, index, datePicked, data }: Props) {
  const { user } = useAuth()

  const { data: scoreCard, isLoading } = useQuery(
    [LBF_QUERY_KEY.QSF_SCORECARD, datePicked, index, data],
    () => getScoreCard(item, datePicked, data, user.company?.id)
  )

  const { data: switchScoreCard, isLoading: switchScoreCardLoading } = useQuery(
    [LBF_QUERY_KEY.QSF_SWITCH_SCORECARD, datePicked, index, data],
    () =>
      getScoreCard(item?.switch_scorecard, datePicked, data, user.company?.id)
  )

  const icon = get(item, 'configure.icon', '')
  const switchIcon = get(item, 'switch_scorecard.configure.icon', '')

  const backgroundColor = get(item, [
    'configure',
    'options',
    'backgroundColor',
    '0',
  ])
  const flipBackgroundColor = get(item, [
    'switch_scorecard',
    'configure',
    'options',
    'backgroundColor',
    '0',
  ])

  if (isLoading || switchScoreCardLoading)
    return (
      <Col span={6} key={index}>
        <Spin spinning indicator={<LiveboardSpinner width={127} />}>
          <ScoreCard
            sign={item?.sign}
            precision={item?.precision}
            showPercentage={item?.showPercentage}
            icon={''}
            score={0}
            subTitle={item.name}
            percentage={0}
            backgroundColor={backgroundColor ?? cardColors[index]}
          />
        </Spin>
      </Col>
    )

  if (item.is_switchable) {
    return (
      <Col span={6} key={index}>
        <FlipFingerContainer
          frontComponent={
            <ScoreCard
              sign={item?.sign}
              precision={item?.precision}
              icon={icon}
              score={scoreCard?.score}
              showPercentage={item?.showPercentage}
              subTitle={item.name}
              percentage={scoreCard?.percentage}
              backgroundColor={backgroundColor ?? cardColors[index]}
            />
          }
          backComponent={
            <ScoreCard
              sign={item?.switch_scorecard?.sign}
              precision={item?.switch_scorecard?.precision}
              icon={switchIcon}
              score={switchScoreCard?.score}
              showPercentage={item?.showPercentage}
              subTitle={item.switch_scorecard.name}
              percentage={switchScoreCard?.percentage ?? null}
              backgroundColor={flipBackgroundColor ?? cardColors[index]}
            />
          }
        />
      </Col>
    )
  }

  return (
    <Col span={6} key={index}>
      <ScoreCard
        sign={item?.sign}
        precision={item?.precision}
        icon={icon}
        score={scoreCard?.score}
        subTitle={item.name}
        percentage={scoreCard?.percentage}
        backgroundColor={backgroundColor ?? cardColors[index]}
      />
    </Col>
  )
}

export default LBScoreCard
